export const SEGMENT = {
  autonomos: 'AU',
  particulares: 'GP',
  particulares_sc: 'GPSC',
};
export const BUBBLE_TEXTS = {
  BUBBLE_ERROR_TEXT: ['Campos obligatorios sin completar'],
};
export const TAX_MAP = {
  IPSI_CEUTA: 'IPSI',
  IPSI_MELILLA: 'IPSI',
  IGIC: 'IGIC',
  IVA: 'IVA',
};
export const LINE_TYPE = {
  LAND_LINE: 'LAND_LINE',
  MOBILE_LINE: 'MOBILE_LINE',
};
export const DEVICE_KIND = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  TABLET: 'TABLET',
  MEDIUM: 'MEDIUM',
};
export const VALIDATE_SMS_ERRORS = {
  457: 'El código ha caducado. Debes solicitar uno nuevo',
  456: 'El código introducido no es correcto.',
  default: 'El código introducido no es correcto.',
};
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
export const RECAPTCHA_KEY =
  currentEnv !== 'prod'
    ? '6LfX050lAAAAAFcmcOy1KdiEi2k5bBrmqWptug1V'
    : '6LekoJ0lAAAAAHv_IXXvHAPqt43_lzzyXf61h0fV';

export const LOGIN_URL = 'https://www.movistar.es/auth/login';
export const CONFIG_URL = 'https://www.movistar.es/fibra-y-movil/';
export const TCOL_FORM = 'https://www.movistar.es/fibra-y-movil/';
export const FA_URL =
  'https://www.movistar.es/tarifas-moviles/lineas-adicionales/';
export const CLIENT_TYPE = {
  CLIENT: 'client',
  NO_CLIENT: 'no_client',
  SOFT_CLIENT: 'soft_client',
};
export const SESSION_STORAGE_PRODUCT_INFO = 'sessionStorageProductInfo';
export const RECURRING_TYPE = { DAY: 'DAY', MONTH: 'MONTH' };
export const QUOTE_TEXT = {
  [RECURRING_TYPE.DAY]: 'día*',
  [RECURRING_TYPE.MONTH]: 'mes',
};

export const CONFIRMATION_TEXTS = {
  TITLE: 'Pedido realizado con éxito',
  TEXT1: 'Recibirás un mail de confirmación y después verás reflejado el cambio en la app y la web.',
  TEXT2: 'Muchas gracias por confiar en Movistar.',
}

export const CONFIRMATION_TEXTS_TV = {
   TITLE: 'Solicitud registrada con éxito',
  TEXT1: 'Tu cambio se hará efectivo en las próximas horas.',
  TEXT2: 'Muchas gracias por confiar en Movistar.',
}